import { __assign, __extends } from "tslib";
import * as React from 'react';
import { PureComponent } from 'react';
import PortalContext from './inner/PortalContext';
import PortalCreator from './inner/PortalCreator';
import PortalProvider from './inner/PortalProvider';
/**
 * @class
 */
var Portal = /** @class */ (function (_super) {
    __extends(Portal, _super);
    function Portal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @returns {React.Element}
     */
    Portal.prototype.render = function () {
        var _a = this.props, children = _a.children, refProp = _a.refProp;
        return (React.createElement(PortalContext.Consumer, null, function (portalProps) { return (React.createElement(PortalCreator, __assign({ ref: refProp }, portalProps), children)); }));
    };
    Portal.contextType = PortalContext;
    Portal.defaultProps = {
        children: [],
        refProp: undefined
    };
    Portal.Provider = PortalProvider;
    return Portal;
}(PureComponent));
export { PortalProvider, Portal as default, PortalCreator };
//# sourceMappingURL=Portal.js.map